import { buttoBaseStyle } from '@screens/lp-default/styles';
import styled from 'styled-components';

export const Container = styled.section`
  background-color: ${({ theme }) => theme.elsie.colors.canvas.soft};
  color: ${({ theme }) => theme.elsie.colors.content.accent};
  display: flex;
  flex-direction: column;
  padding: 80px 64px;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.elsie.colors.content.accent};
  font-size: ${({ theme }) => theme.elsie.fontSize['2xl']};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.sm};
  margin-bottom: 20px;
`;

export const Text = styled.span`
  font-size: 15px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: 0;
`;

export const CheckoutButton = styled.button`
  ${buttoBaseStyle};
  width: max-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  background-color: ${({ theme }) => theme.elsie.colors.interactive.accent.default};
  color: ${({ theme }) => theme.elsie.colors.content.onInteractive.accent};
  gap: ${({ theme }) => theme.elsie.dimension[8]};
  padding: 10px ${({ theme }) => theme.elsie.dimension[16]};
  font-size: 15px;
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  &:hover {
    background-color: ${({ theme }) => theme.elsie.colors.interactive.accent.hovered};
  }
  &:active {
    background-color: ${({ theme }) => theme.elsie.colors.interactive.accent.pressed};
  }
  @media only screen and (min-width: 1024px) {
    padding: 13px ${({ theme }) => theme.elsie.dimension[16]};
    font-size: 17px;
    border-radius: ${({ theme }) => theme.elsie.borderRadius.lg};
  }
  @media only screen and (max-width: 1023px) {
    margin-top: 0;
    width: 100%;
  }

  @media only screen and (min-width: 1024px) {
    margin-top: 16px;
  }
`;
